import { useAsync } from 'react-async-hook';
import * as sched from 'sched';
import { useAuth } from './useAuth';

export const useListViewerWorkspaces = () => {
  const { user, token, client } = useAuth();

  const { result, loading, error } = useAsync(async () => {
    if (!user || !token || !client) return null;

    const workspaces = await sched.WrappedApiClient.list_viewer_workspaces(client, token);

    return workspaces;
  }, [user, token]);

  return { workspaces: result, loading, error };
};